import { fetchVersionByName } from "reducers/VersionDetails";
import { maxLength } from "./validators";

const VERSION_NAME_MAX_LENGTH = 250;
const VERSION_NAME_PATTERN = /^[\w\säöüÄÖÜß\_\.\-\~]*$/;
const VERSION_ERROR_MESSAGE = "Version names must only contain the following characters: Alphanumeric, spaces, and the following characters: _ . - ~ ä ö ü Ä Ö Ü ß";

// For use with async validation when duplicating Versions
export async function versionNameExists(dispatch, libraryId, creativeId, newVersionName, fieldName){
	let version = await dispatch(fetchVersionByName(libraryId, creativeId, newVersionName));
	if(version){
		throw {
			[fieldName]: `A Version already exists with name: ${newVersionName}`,
		};
	}
	return undefined;
}

export function validVersionNameCharacters(value){
	if(!VERSION_NAME_PATTERN.test(value)){
		return VERSION_ERROR_MESSAGE;
	}
	return undefined;
}

export const versionNameMaxLength = maxLength(VERSION_NAME_MAX_LENGTH);
